module.exports = __webpack_public_path__ + "img/2-card-teenpatti.cc8e4f2.png";